import { useTypedQuery } from "hooks";
import { SEASONS } from "models";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Appointment, CarTyres } from "models";

const seasonToDBBTyreType = (season: SEASONS) => {
  if (season === SEASONS.Summer) return "S";
  if (season === SEASONS.Winter) return "W";
  return "A";
};

const getStorageTyres = (inStorageTyres?: CarTyres) => {
  if (!inStorageTyres) return [];

  return [
    { tyre: inStorageTyres.front_left_tyre, profile: inStorageTyres.fl_profile },
    { tyre: inStorageTyres.front_right_tyre, profile: inStorageTyres.fr_profile },
    { tyre: inStorageTyres.rear_left_tyre, profile: inStorageTyres.rl_profile },
    { tyre: inStorageTyres.rear_right_tyre, profile: inStorageTyres.rr_profile }
  ];
};

export const useDBBTyreLimits = (appointment: Appointment) => {
  const { data: tyreLimits, isFetching: isFetchingTyreLimits } = useTypedQuery({
    queryKey: AppointmentDetailsKeys.tyreLimits,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, { appointment_id: appointment.id }, baseUrl)).data.tyre_limits,
    enabled: appointment.car?.has_dbb && !appointment.car.dbb_appointment_date && !appointment.car.dbb_tyre_pickup_requested_at
  });

  const storageTyres = getStorageTyres(appointment.car?.in_storage_tyres);
  const hasStorageTyreBelowNecessaryTreadDepth = storageTyres.some(({ tyre, profile }) => {
    if (!tyre) return false;

    const tyreType = seasonToDBBTyreType(tyre.season);
    return tyreLimits?.some(tyreLimit => tyreLimit.TyreType === tyreType && profile <= tyreLimit.NecessaryTreadDepth);
  });

  return { tyreLimits, hasStorageTyreBelowNecessaryTreadDepth, isFetchingTyreLimits };
};
